export enum ExternalLoginSystem {
    DNT = 0
}